/**
 * Count-up animation for span.number[data-value] elements (big-stat block).
 * Numbers animate from 0 when scrolled into view; honors reduced motion.
 */

const DURATION = 2000;

function format(value: number, decimals: number): string {
  return value.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

function animate(el: HTMLElement) {
  const end = parseFloat(el.dataset.value ?? '');
  if (Number.isNaN(end)) return;

  const decimals = (el.dataset.value ?? '').split('.')[1]?.length ?? 0;
  const start = performance.now();

  const tick = (now: number) => {
    const progress = Math.min((now - start) / DURATION, 1);
    const eased = 1 - Math.pow(1 - progress, 3);
    el.textContent = format(end * eased, decimals);
    if (progress < 1) requestAnimationFrame(tick);
  };

  requestAnimationFrame(tick);
}

export default function numbers() {
  const els = document.querySelectorAll<HTMLElement>('span.number[data-value]');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animate(entry.target as HTMLElement);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  els.forEach((el) => observer.observe(el));
}
